import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "backdrop", "group"]

  connect() {
    this.close()
    this.syncGroupAria()
  }

  toggle() {
    if (this.sidebarTarget.classList.contains("is-open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.sidebarTarget.classList.add("is-open")
    document.body.classList.add("admin-sidebar-open")
  }

  close() {
    this.sidebarTarget.classList.remove("is-open")
    document.body.classList.remove("admin-sidebar-open")
  }

  toggleGroup(event) {
    const group = event.currentTarget.closest(".admin-nav-group")
    if (!group) return
    group.classList.toggle("is-collapsed")
    this.syncGroupAria(group)
  }

  syncGroupAria(scope = this.element) {
    scope.querySelectorAll(".admin-nav-group").forEach((group) => {
      const button = group.querySelector(".admin-nav-group__toggle")
      if (!button) return
      button.setAttribute("aria-expanded", String(!group.classList.contains("is-collapsed")))
    })
  }
}
